/**
 * Wallet Screening Service
 *
 * API methods for crypto wallet screening and transaction monitoring.
 * All methods support abort signals for request cancellation.
 */

import { ApiClient } from './api';

export class WalletScreeningService {
  constructor(getToken) {
    this.client = new ApiClient(getToken);
  }

  /**
   * Get wallet screenings for an applicant
   */
  getByApplicant(applicantId, options = {}) {
    return this.client.get(`/wallet-screening/${applicantId}`, options);
  }

  /**
   * Screen a wallet address
   */
  screenWallet(data, options = {}) {
    return this.client.post('/wallet-screening/screen', data, options);
  }

  /**
   * Import wallet screening from external provider
   */
  importScreening(data, options = {}) {
    return this.client.post('/wallet-screening/import', data, options);
  }

  /**
   * Resolve a wallet screening hit
   */
  resolveScreening(screeningId, resolution, notes, options = {}) {
    return this.client.post(`/wallet-screening/${screeningId}/resolve`, {
      resolution_status: resolution,
      notes,
    }, options);
  }
}

export default WalletScreeningService;
